module.exports = __webpack_public_path__ + "static/media/speed_dating.5647acd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/narratives/speed_dating.jpg
// module id = 1248
// module chunks = 0